import React, { useState } from "react";
import { Box } from "@mui/material";
import { detailsTabsBoxStyle } from "../../services/Utils";
import Constants from "../../services/Constants";
import { DataGrid } from "@mui/x-data-grid";
import { getColumnsData } from "./VehiclesListInVehicleGroupColumns";
import GoToPageToolbar from "../common/GoToPageToolbar";

const VehiclesInGroupTab = (props) => {
  const [pageSize, setPageSize] = React.useState(Constants.PAGE_SIZE);
  const [page, setPage] = useState(0);

  let vehicleData = [];

  if (props?.groupData?.devices?.flat().length) {
    vehicleData = props?.groupData?.devices?.flat()?.map((vehicle) => {
      return vehicle;
    });
  }
  const totalPages = Math.ceil(vehicleData.length / pageSize) || 1;

  return (
    <Box {...detailsTabsBoxStyle}>
      <DataGrid
        page={page}
        onPageChange={(newPage) => setPage(newPage)}
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => {
          setPageSize(newPageSize);
          setPage(0);
        }}
        rowsPerPageOptions={Constants.ROWS_PER_PAGE_OPT}
        pagination
        loading={props.groupDataLoading}
        rows={vehicleData}
        columns={getColumnsData()}
        sx={{ height: "calc(100vh - 290px)" }}
        checkboxSelection={false}
        getRowId={(row) => row?.serialNo}
        components={{
          Toolbar: GoToPageToolbar,
        }}
        componentsProps={{
          toolbar: {
            totalPages,
            page,
            onPageChange: (newPage) => setPage(newPage),
          },
        }}
      />
    </Box>
  );
};

export default VehiclesInGroupTab;
